var WokService = (function () {

    'use strict';

    //************ Variables ************//
    var stepItems = {};
    var selectedItems = {};
    var isStandartType = true;
    var list;
    var categoryId;
    var category;
    var price;
    var quantity;
    var sentEcommerce = false;
    let currentStepMobile = 1;
    const EGG_TITLE = "Куриное яйцо";

    //************ Functions ************//
    function successAddWok() {
        removeAll();
    }

    function ecommerceImpressions() {
        var impressions = [];

        $('.voki').filter(function () {
            var groupElement = $(this);
            var name = groupElement.data('name');
            var id = groupElement.data('id');
            var category = groupElement.data('category');
            var list = groupElement.data('list');
            var position = 1;

            var item = {
                'name': name,
                'id': id,
                'category': category,
                'list': list,
                'position': position
            };
            impressions.push(item);
        });

        if (impressions.length !== 0) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'ecommerceImpressions',
                'ecommerce': {
                    'impressions': impressions
                }
            });
        }
    }

    function ecommerceClick(isAddition, list, name, categoryId, price, category, quantity) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommerceClick',
            'ecommerce': {
                'click': {
                    'actionField': {
                        'list': list
                    },
                    'products': [
                        {
                            'name': name,
                            'id': categoryId,
                            'price': price,
                            'category': category,
                            'position': 1
                        }
                    ]
                }
            }
        });

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommerceDetail',
            'ecommerce': {
                'detail': {
                    'actionField': {
                        'list': list
                    },
                    'products': [
                        {
                            'name': name,
                            'id': categoryId,
                            'price': price,
                            'category': category
                        }
                    ]
                }
            }
        });

        if (isAddition) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'ecommerceAdd',
                'ecommerce': {
                    'add': {
                        'products': [
                            {
                                'name': name,
                                'id': categoryId,
                                'price': price,
                                'category': category,
                                'quantity': quantity
                            }
                        ]
                    }
                }
            });
        } else {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'ecommerceRemove',
                'ecommerce': {
                    'remove': {
                        'products': [
                            {
                                'name': name,
                                'id': categoryId,
                                'price': price,
                                'category': category,
                                'quantity': quantity
                            }
                        ]
                    }
                }
            });
        }
    }

    const changeStepMobile = step => {
        Array.from(document.getElementsByClassName('js__wok-constructor__step-mobile'))
            .forEach(elem => elem.classList.remove('active'));
        document.getElementById(`wokConstructor${step}StepMobile`).classList.add('active');
    };

    const clickNavigationHandler = () => {
        $('.js__navigation__next').on('click', event => {
            const step = $(event.currentTarget).data('step');
            if (validate(currentStepMobile)) {
                currentStepMobile = step;
                changeStepMobile(step);
            }
        });

        $('.js__navigation__back').on('click', event => {
            const step = $(event.currentTarget).data('step');
            currentStepMobile = step;
            changeStepMobile(step);
        });
    };

    const handleStepMobileSwipe = () => {
        $('.js__wok-constructor__step-mobile').on('swipeleft', event => {
            const step = $(event.currentTarget).data('step');
            if (validate(currentStepMobile)) {
                const stepTo = step + 1;

                if (stepTo <= 5) {
                    currentStepMobile = stepTo;
                    changeStepMobile(stepTo);
                }
            }
        });

        $('.js__wok-constructor__step-mobile').on('swiperight', event => {
            const step = $(event.currentTarget).data('step');
            const stepTo = step - 1;

            if (stepTo > 0) {
                currentStepMobile = stepTo;
                changeStepMobile(stepTo);
            }
        });
    };

    const handleCheckboxClick = () => {
        $('.js__form__checkbox-mobile').filter(function () {
            const $elem = $(this);

            $elem.find('.js__form__description-mobile').on('click', () => {
                $elem.find('.js-wok-menu-step-checkbox').trigger('click');
            });
        });
    };

    function init() {
        initData();

        var name = $('.js-voki').data('name');
        list = $('.js-voki').data('list');
        categoryId = $('.js-voki').data('category-id');
        category = $('.js-voki').data('category');

        $('.js-order').on('click', '.js-item-control > .voki-step-order-item-control-minus', function () {
            var count = $(this).next().text() - 1;

            var section = $(this).closest('section');
            var id = section.find('.js-order-item-group-id').val();
            var step = $('#' + id).data('step');

            if (count === 0) {
                delete selectedItems[id];
                $('#' + id).prop("checked", false);
                $(`#${id}_mobile`).prop("checked", false);

                section.remove();
            } else {
                $(this).next().text(count);
                selectedItems[id].count = count;

                if (stepItems[id].title === EGG_TITLE) {
                    if (count === 1) {
                        $(this).parent().prev().prev().text('0 р.');
                        $('#' + id).parent().find('.js-price-red').text('0р.');
                    } else {
                        $(this).parent().prev().prev().text(stepItems[id].standartPrice + ' р.');
                        $('#' + id).parent().find('.js-price-red').text(stepItems[id].standartPrice + 'р.');
                    }
                }
            }

            updateTotalPrice();
        });

        $('.js-order').on('click', '.js-item-control > .voki-step-order-item-control-plus', function () {
            var section = $(this).closest('section');
            var id = section.find('.js-order-item-group-id').val();
            var step = $('#' + id).data('step');
            var max = $('#' + id).data('max');
            var count = parseInt($(this).prev().text()) + 1;

            $(this).prev().text(count);
            selectedItems[id].count = count;

            if (stepItems[id].title === EGG_TITLE) {
                if (count === 1) {
                    $(this).parent().prev().prev().text('0 ₽');
                    $('#' + id).parent().find('.js-price-red').text('0 ₽');
                } else {
                    $(this).parent().prev().prev().text(stepItems[id].standartPrice + ' ₽');
                    $('#' + id).parent().find('.js-price-red').text(stepItems[id].standartPrice + ' ₽');
                }
            }

            updateTotalPrice();
        });

        $('.js-wok-menu-step-checkbox').change(function () {
            var id = $(this).attr('id').replace('_mobile', '');
            var step = $(this).data('step');
            var max = $(this).data('max');

            if ($(this).is(":checked")) {
                $('.js-order').removeClass('hidden');

                switch (step) {
                    case 1:
                        $(".js-wok-menu-step-checkbox[data-step='1']").prop("checked", false);
                        $(this).prop("checked", true);
                        $('.js-wok-step-one-error-alert').addClass('hidden');

                        removeStepItem(1);
                        createItem(id, step);
                        break;
                    case 2:
                        $('.js-wok-step-two-error-alert').addClass('hidden');
                        createItem(id, step);
                        break;
                    case 3:
                        $(".js-wok-menu-step-checkbox[data-step='3']").prop("checked", false);
                        $(this).prop("checked", true);
                        $('.js-wok-step-three-error-alert').addClass('hidden');

                        removeStepItem(3);
                        createItem(id, step);
                        break;
                    case 4:
                        createItem(id, step);
                        break;
                }
                updateTotalPrice();
                checkToShowOrderInfo();
                return;
            }
            removeItem(id);
            updateTotalPrice();
            checkToShowOrderInfo();
        });

        $('.js__voki-step-order-counter-controls > .js__voki-step-order-counter-controls-minus').on('click', function () {
            var count = $('.js-menu-order-counter').text() - 1;
            if (count > 0) {
                $('.js-menu-order-counter').text(count);
                $('.js-menu-order-counter-mobile').text(count);

                updateTotalPrice();
            }
        });

        $('.js__voki-step-order-counter-controls > .js__voki-step-order-counter-controls-plus').on('click', function () {
            var count = parseInt($('.js-menu-order-counter').text()) + 1;
            $('.js-menu-order-counter').text(count);
            $('.js-menu-order-counter-mobile').text(count);

            updateTotalPrice();
        });

        $('.js-wok-menu-type-buttons > button').on('click', function () {
            $('.js-wok-menu-type-buttons > button.active').removeClass('active');
            $(this).addClass('active');

            changeType();
        });

        $('.js-wok-order-reset').on('click', function () {
            price = getPrice();
            quantity = parseInt($('.js-menu-order-counter').text());
            removeAll();
            $('.js-order').addClass('hidden');
            ecommerceClick(false, list, name, categoryId, price, category, quantity);

            document.getElementById('wokConstructor5StepMobile').classList.remove('active');
            document.getElementById('wokConstructor1StepMobile').classList.add('active');
            currentStepMobile = 1;
        });

        $(".js-basket-add-wok").on('click', event => {
            if (validate()) {
                wokToBasket();
                $('.js-order').addClass('hidden');
                price = getPrice();
                quantity = parseInt($('.js-menu-order-counter').text());
                ecommerceClick(true, list, name, "00000000000000", price, category, quantity);

                document.getElementById('wokConstructor5StepMobile').classList.remove('active');
                document.getElementById('wokConstructor1StepMobile').classList.add('active');
                currentStepMobile = 1;
            }
        });

        $(".js_vsol_add-to-favorites").on('click', () => {
            if (validate()) {
                $('#addWokModal').modal('show');
            }
        });

        $('.js_basket-add-wok-modal').on('click', event => {
            $('.modal.in').modal('hide');

            const customWokId = addCustomWok();
            if (customWokId.length > 0) {
                const sushiUserFavouriteItemRequest = {
                    woksIds: [customWokId]
                };
                $.ajax({
                    url: '/api/v5/sushi-user-favorite-item/add?fromWeb=true',
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(sushiUserFavouriteItemRequest)
                });
            }

            const isAddToBasket = $(event.target).data('is-add-to-basket');
            if (isAddToBasket) {
                wokToBasket();
                $('.js-order').addClass('hidden');
                price = getPrice();
                quantity = parseInt($('.js-menu-order-counter').text());
                ecommerceClick(true, list, name, categoryId, price, category, quantity);
            }
        });

        $('.js-select-finished-wok').on('click', function () {
            $('.js-wok-constructor').hide();
            $('.js-finished-wok').show();
            if (!sentEcommerce) {
                sentEcommerce = true;
                DishesService.ecommerceImpressions();
            }
        });

        $('.js-select-wok-constructor').on('click', function () {
            $('.js-finished-wok').hide();
            $('.js-wok-constructor').show();

            history.pushState("", document.title, window.location.pathname
                + window.location.search);

        });

        ecommerceImpressions();
        clickNavigationHandler();
        handleStepMobileSwipe();
        handleCheckboxClick();
    }

    /**
     * Заполняем глобальную переменную данными о ингридентах
     */
    function initData() {
        $('.js__step-1-form input').each(function (index, element) {
            var id = $(element).attr('id').replace('_mobile', '');
            stepItems[id] = getItemData(element);
        });

        $('.js__step-2-form input').each(function (index, element) {
            var id = $(element).attr('id').replace('_mobile', '');
            stepItems[id] = getItemData(element);
        });

        $('.js__step-3-form input').each(function (index, element) {
            var id = $(element).attr('id').replace('_mobile', '');
            stepItems[id] = getItemData(element);
        });

        $('.js__step-4-form input').each(function (index, element) {
            var id = $(element).attr('id').replace('_mobile', '');
            stepItems[id] = getItemData(element);
        });
    }

    /**
     * Получаем данные ингридиента из data значений поля
     */
    function getItemData(element) {
        var id = $(element).attr('id').replace('_mobile', '');
        var title = $(element).data('title');
        var description = $(element).data('description');
        var picture = $(element).data('img');
        var standartId = $(element).data('standart-id');
        var standartPrice = $(element).data('standart-price');
        var economicId = $(element).data('economic-id');
        var economicPrice = $(element).data('economic-price');
        var step = $(element).data('step');

        var item = {
            id: id,
            title: title,
            description: description,
            picture: picture,
            standartId: standartId,
            standartPrice: standartPrice,
            economicId: economicId,
            economicPrice: economicPrice,
            step: step
        };

        return item;
    }

    /**
     * Выбрали новую позицию
     */
    function createItem(id, step) {
        var item = stepItems[id];

        selectedItems[id] = {
            count: 1,
            item: item,
            step: parseInt(step)
        };

        var section = $('.js-order-item.hidden').clone();
        section.addClass(item.id);
        section.removeClass('hidden');
        section.find('.js-order-item-group-id').val(item.id);
        section.find('.img-responsive').attr('src', item.picture);
        section.find('.voki-step-order-item-name')[0].childNodes[0].nodeValue = item.title;
        section.find('.voki-step-order-item-desc').text(item.description);

        if (isStandartType) {
            section.find('.js-order-item-id').val(item.standartId);
            section.find('.voki-step-price').text(item.standartPrice + ' р.');
        } else {
            section.find('.js-order-item-id').val(item.economicId);
            section.find('.voki-step-price').text(item.economicPrice + ' р.');
        }

        if (item.title === EGG_TITLE) {
            section.find('.voki-step-price').text('0 р.');
        }

        if (step == 1 || step == 3) {
            section.find('.voki-step-order-item-control').addClass('hidden');
        }

        $('.js-order-section-step-' + step).prepend(section);
    }

    /**
     * Uncheck позиции
     */
    function removeItem(id) {
        delete selectedItems[id];
        $('.js-order-item.' + id).remove();
    }

    function removeStepItem(step) {
        $.each(stepItems, function (id, item) {
            if (item.step == step) {
                removeItem(id);
            }
        });
    }

    /**
     * Обновляем итоговую цену товара
     */
    function updateTotalPrice() {
        var count = $('.js-menu-order-counter').text();
        var keys = Object.keys(selectedItems);
        var totalPrice = 0;

        for (var i = 0; i < keys.length; i++) {
            var id = keys[i];
            var item = selectedItems[id];

            if (item.item.title === EGG_TITLE) {
                totalPrice += (item.count - 1) * item.item.standartPrice;
            } else if (isStandartType) {
                totalPrice += item.count * item.item.standartPrice;
            } else {
                totalPrice += item.count * item.item.economicPrice;
            }
        }

        $('.js__final-price > .value').text(totalPrice * count + ' ₽');
    }

    function getPrice() {
        var keys = Object.keys(selectedItems);
        var price = 0;

        for (var i = 0; i < keys.length; i++) {
            var id = keys[i];
            var item = selectedItems[id];

            if (item.item.title === EGG_TITLE) {
                price += (item.count - 1) * item.item.standartPrice;
            } else if (isStandartType) {
                price += item.count * item.item.standartPrice;
            } else {
                price += item.count * item.item.economicPrice;
            }
        }

        return price;
    }

    /**
     * Меняем тип цены у всех товаров
     */
    function changeType() {
        $('.js-order').removeClass('hidden');
        isStandartType = $('.js-wok-menu-type-buttons > button.active').text() == 'Big';

        // change prices in step two
        $('.js__step-2-form .checkbox').each(function (index, element) {
            var checkbox = $(element);
            var id = checkbox.find('input').attr('id').replace('_mobile', '');

            if (isStandartType) {
                checkbox.find('.js-price-red').text(stepItems[id].standartPrice + "р.");
            } else {
                checkbox.find('.js-price-red').text(stepItems[id].economicPrice + "р.");
            }
            if (stepItems[id].title === EGG_TITLE) {
                $('#' + id).parent().find('.js-price-red').text('0р.');
            }

        });

        // change price in builder
        $('.js-order-item:not(.hidden)').each(function (index, element) {
            var section = $(element);
            var id = section.find('.js-order-item-group-id').val();

            if (isStandartType) {
                section.find('.js-order-item-price').text(stepItems[id].standartPrice + ' р.');
                section.find('.js-order-item-id').val(stepItems[id].standartId);
            } else {
                section.find('.js-order-item-price').text(stepItems[id].economicPrice + ' р.');
                section.find('.js-order-item-id').val(stepItems[id].economicId);
            }

            if (stepItems[id].title === EGG_TITLE) {
                if (selectedItems[id].count <= 1) {
                    section.find('.js-order-item-price').text('0 р.');
                    $('#' + id).parent().find('.js-price-red').text('0р.');
                } else {
                    section.find('.js-order-item-price').text(stepItems[id].standartPrice + ' р.');
                    $('#' + id).parent().find('.js-price-red').text(stepItems[id].standartPrice + 'р.');
                }
            }
        });

        updateTotalPrice();
    }

    /**
     * Сбрасываем всю корзину с ингридиентами
     */
    function removeAll() {
        $('.js-menu-order-counter').text('1');
        $('.js-menu-order-counter-mobile').text('1');
        $('.js-order-error').addClass('mod-hidden');
        $('.js-order-item:not(.hidden)').each(function (index, element) {
            $(element).remove();

            var keys = Object.keys(selectedItems);
            for (var i = 0; i < keys.length; i++) {
                $('#' + keys[i]).prop('checked', false);
                $('#' + keys[i] + '_mobile').prop('checked', false);
            }

            selectedItems = {};

            updateTotalPrice();
        });
    }

    const getWokItems = () => {
        const steps = [
            [],
            [],
            [],
            []
        ];

        const keys = Object.keys(selectedItems);
        for (let i = 0; i < keys.length; i++) {
            const id = keys[i];
            const selectedItem = selectedItems[id];
            let ingredient;

            if (isStandartType) {
                ingredient = {
                    itemGroupId: selectedItem.item.id,
                    itemId: selectedItem.item.standartId,
                    count: selectedItem.count
                };
            } else {
                ingredient = {
                    itemGroupId: selectedItem.item.id,
                    itemId: selectedItem.item.economicId,
                    count: selectedItem.count
                };
            }
            steps[selectedItem.step - 1].push(ingredient);
        }
        let items = [];
        $.each(steps, function (index, item) {
            items = items.concat(item);
        });
        return items;
    };

    /**
     * Добавляем вок в корзину
     */
    function wokToBasket() {
        const title = $('.js_modal-wok-title').val();
        const count = $('.js-menu-order-counter').text();
        let items = getWokItems();

        AnimationsService.animate.basket();
        BasketService.addWok(title, items, count, successAddWok);
    }

    const addCustomWok = () => {
        const title = $('.js_modal-wok-title').val();
        const count = $('.js-menu-order-counter').text();
        let items = getWokItems();

        let composites = [];

        items.forEach(item => {
            const wokItem = {
                id: item.itemGroupId,
                itemId: item.itemId,
                count: item.count
            };
            composites.push(wokItem);
        });

        const data = {
            wokName: title,
            wokType: isStandartType ? 'BIG' : 'LIGHT',
            composites: composites,
            count: count
        };

        let response = "";
        $.ajax({
            url: '/api/v2/sushi-user-favorite-item/addCustomWok',
            type: 'POST',
            async: false,
            data: JSON.stringify(data),
            contentType: 'application/json'
        })
            .done(({result}) => {
                response = result;
            });
        return response;
    };

    /**
     * Првоеряем данные перед добавлением в корзину
     * @returns {boolean}
     */
    function validate(step) {
        $('.js-order-error').addClass('mod-hidden');
        let isValidate = true;

        if (step === undefined) {
            for (let i = 1; i < 4; i++) {
                if ($(`.js-wok-menu-step-checkbox:checked[data-step=${i}]`).length === 0) {
                    isValidate = false;
                    $(`.js-step-${i}-error`).removeClass('mod-hidden');
                }
            }
        } else if (step < 4) {
            if ($(`.js-wok-menu-step-checkbox:checked[data-step=${step}]`).length === 0) {
                isValidate = false;
                $(`.js-step-${step}-error`).removeClass('mod-hidden');
            }
        }
        return isValidate;
    }

    function checkToShowOrderInfo() {
        if (selectedItems.length > 0) {
            $('.js-order-main-info').each(function () {
                $(this).removeClass('hidden');
            });
        } else {
            $('.js-order-main-info').each(function () {
                $(this).addClass('hidden');
            });
        }
    }

    //************ Public ************//
    return {
        init: init,
        successAddWok: successAddWok
    };
})();

$(WokService.init);